import Axios from 'axios';
import { Codes } from 'api';
import { Message } from 'element-ui';
import { getRequest } from '../string';
const api = Axios.create();
const base_url = process.env.VUE_APP_SCRM_API_BASE;
export const wecom_param_key = 'wecom_param';
export const eid_key = 'WECOM_EID';
const apis = {
  auth: '/api/v1/wecom/app/hsylc/oauth',
  eid: '/api/v1/wecom/app/hsylc/authorize'
};
const toast = {
  success: msg => {
    Message.success(msg);
  },
  error: msg => {
    Message.error(msg);
  }
};
export const postOauth = async (return_url, fail_url) => {
  const url = `${base_url}${apis.auth}`;
  return new Promise((resolve, reject) => {
    api
      .post(url, {
        scope: 'base',
        return_url
      })
      .then(_res => {
        const res = _res.data;
        const code = res.code;
        if (code) {
          toast.error(res.message);
          reject(res);
          window.location.href = fail_url;
        } else {
          resolve(res.data);
          window.location.href = res.data.url;
        }
      })
      .catch(ex => {
        toast.error(JSON.stringify(ex));
        window.location.href = fail_url;
      });
  });
};
export const getEId = code => {
  const url = `${base_url}${apis.eid}`;
  let eid = getRequest()?.eid || '';
  return new Promise((resolve, reject) => {
    if (eid) {
      localStorage.setItem(eid_key, eid);
      resolve({
        status: Codes.SUCCESS,
        data: eid
      });
    } else if (code) {
      api.post(url, { code }).then(_res => {
        const res = _res.data;
        const code = res.code;
        if (code) {
          reject({
            status: code,
            msg: '获取eid失败'
          });
        } else if (res.data?.external_user_id) {
          localStorage.setItem(eid_key, res.data.external_user_id);
          resolve({
            status: Codes.SUCCESS,
            data: res.data.external_user_id
          });
        } else {
          resolve({
            status: Codes.SUCCESS,
            data: ''
          });
        }
      });
    } else {
      resolve({
        status: Codes.SUCCESS,
        data: localStorage.getItem(eid_key) || ''
      });
    }
  });
};
export const resetEid = userId => {
  localStorage.removeItem(eid_key);
  window.location.replace(`/wecom/seminar?user_id=${userId}`);
};
export const gotoActivity = userId => {
  window.location.replace(`/take-lessons/help?user_id=${userId}`);
};
